export default {
  eyebrow: 'Portal do parceiro',
  title: 'Faturação',
  description: 'O seu método de pagamento para a fatura mensal da plataforma e cada fatura com o seu detalhe completo.',
  toasts: {
    checkout_error: 'Não foi possível iniciar o checkout — tente novamente.',
    action_error: 'A ação falhou — tente novamente.',
    onboarding_error: 'Não foi possível iniciar a verificação — tente novamente.',
    payment_method_in_use:
      'As licenças dos seus restaurantes são cobradas a este método de pagamento, pelo que não pode ser removido. Substitua-o por um novo.',
  },
  payout_bank_account: {
    title: 'Conta bancária para pagamentos',
    description:
      'Os pagamentos da partilha de receitas são recebidos em {{currency}}. A Stripe converte a transferência quando esta chega.',
    toasts: {
      saved: 'Conta bancária guardada',
      save_failed: 'Não foi possível guardar a conta bancária. Verifique os dados.',
    },
  },
  payout_onboarding: {
    title: 'Configure a sua conta de pagamento',
    description:
      'A sua receita partilhada é paga mensalmente a uma conta de pagamento Stripe. Complete a verificação uma vez — os pagamentos ficam em espera até estar concluída.',
    missing: {
      title: 'Ainda necessário antes de os pagamentos poderem começar:',
      bank_account: 'Adicione a conta bancária para a qual a sua partilha de receita deve ser paga.',
      business_details: 'Complete os dados da sua empresa, como morada, NIF ou número de registo.',
      people: 'Adicione os dados do representante, proprietários ou diretores da sua empresa.',
      documents: 'Carregue os documentos de verificação solicitados pela Stripe.',
      terms: 'Aceite os termos de serviço da Stripe.',
      other: 'Forneça os restantes dados solicitados pela Stripe.',
    },
    start: 'Iniciar verificação',
    continue: 'Continuar verificação',
    ready:
      'Conta de pagamento verificada — a sua receita partilhada é paga automaticamente após cada ciclo de faturação.',
  },
  payment_method: {
    title: 'Método de pagamento',
    empty: 'Sem método de pagamento registado — a fatura mensal não pode ser cobrada automaticamente.',
    add: 'Adicionar método de pagamento',
    replace: 'Substituir',
    remove: 'Remover',
    remove_confirm: {
      title: 'Remover este método de pagamento?',
      description:
        'O cartão/mandato é desassociado do Stripe imediatamente. Sem método de pagamento, as faturas — incluindo as já emitidas — são cobradas através da fatura Stripe alojada em vez de automaticamente.',
      confirm: 'Remover',
    },
  },
  invoices: {
    title: 'Faturas',
  },
};
